import React from "react";
import Layout from "../../layout/Layout";
import { Outlet } from "react-router-dom";

const WebContent = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default WebContent;
